<script setup>
import moment from 'moment'
import { useUsersStore, useReservationsStore } from '@/stores'
import Tooltip from '@/layouts/components/Tooltip.vue'
import {
  emailValidator,
  requiredValidator,
  phoneValidator
} from '@validators'

const props = defineProps({
  id: {
    type: String,
    required: true
  }
})

const messageData = {
  1: {
    title: "Membership Accepted",
    message: "The member now has access to RM via your group",
    closeButton: true
  },
  2: {
    title: "Membership Already Accepted",
    message: "You or another admin has already accepted this member into your group",
    closeButton: true
  },
  3: {
    title: "Membership Already Denied or Rescinded",
    message: "You or another admin has already already denied or rescinded this member's request to join your group",
    closeButton: true
  },
  4: {
    title: "Membership Denied",
    message: "The member has now been denied access to RM via your group",
    closeButton: true
  },
  5: {
    title: "Membership Request already Replied",
    message: "The membership request has already been Accepted, Denied or was Rescinded. View the Member Manger for more details.",
    closeButton: true
  }
}

const closeWindow = () => {
  window.close()
}
</script>

<template>
  <div class="content-wrapper mt-6">
    <div>
      <VCard class="pa-10 pt-8">
        <h2>{{ messageData[props.id].title }}</h2>
        <h5>{{ messageData[props.id].message }}</h5>
        <VBtn
          v-if="messageData[props.id].closeButton"
          class="mt-4"
          color="primary"
          @click="closeWindow"
        >
          Close
        </VBtn>
        <VBtn
          v-else
          class="mt-4"
          color="primary"
          :to="messageData[props.id].buttonPath"
        >
          {{ messageData[props.id].buttonLabel }}
        </VBtn>
      </VCard>
    </div>
  </div>
</template>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: AclDemo
  allowLoggedInOnly: false
</route>
